<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="false"
  [styleClass]="tip() === 'period' ? 'date-override-dialog date-override-dialog--wide' : 'date-override-dialog'"
>
  <div class="flex flex-column">
    <app-field label="Tip" for="override-tip-single">
      <div class="flex align-items-center gap-3">
        <div class="flex align-items-center gap-2">
          <p-radiobutton
            inputId="override-tip-single"
            name="override-tip"
            value="single"
            [ngModel]="tip()"
            (ngModelChange)="onTipChange($event)"
          ></p-radiobutton>
          <label for="override-tip-single" class="text-sm-medium text-gray-700 cursor-pointer">Jedan dan</label>
        </div>
        <div class="flex align-items-center gap-2">
          <p-radiobutton
            inputId="override-tip-period"
            name="override-tip"
            value="period"
            [ngModel]="tip()"
            (ngModelChange)="onTipChange($event)"
          ></p-radiobutton>
          <label for="override-tip-period" class="text-sm-medium text-gray-700 cursor-pointer">Period</label>
        </div>
      </div>
    </app-field>

    <app-field class="mt-3-5" label="Izaberite datum" for="override-date">
      @if (tip() === 'single') {
        <app-calendar
          [formCtrl]="singleDateCtrl"
          formCtrlId="override-date"
          [inline]="true"
          [ctrlShowTime]="false"
          [unavailableDays]="unavailableDays()"
          [hideErrors]="true"
        ></app-calendar>
      } @else {
        <app-calendar
          [formCtrl]="rangeCtrl"
          formCtrlId="override-date"
          [inline]="true"
          [ctrlShowTime]="false"
          selectionMode="range"
          [numberOfMonths]="2"
          [unavailableDays]="unavailableDays()"
          [hideErrors]="true"
        ></app-calendar>
      }
    </app-field>

    <app-field class="mt-2" label="Izaberite vreme" for="override-ceo-dan">
      <div class="flex align-items-center gap-2">
        <p-toggleswitch
          inputId="override-ceo-dan"
          [ngModel]="ceoDan()"
          (ngModelChange)="ceoDan.set($event)"
        ></p-toggleswitch>
        <div class="flex flex-column">
          <div class="text-sm-medium text-gray-700">Ceo dan</div>
          <div class="text-sm-regular text-gray-600">Neradni period ceo dan</div>
        </div>
      </div>

      @if (!ceoDan()) {
        <div class="grid mt-1">
          <div class="col-12 md:col-6">
            <app-field label="Od" for="override-from">
              <app-calendar
                [formCtrl]="fromCtrl"
                formCtrlId="override-from"
                [timeOnly]="true"
                [ctrlShowTime]="true"
                dateFormat=""
                panelStyleClass="admin-settings-time-picker"
                ctrlPlaceholder="Izaberite vreme"
                [hideErrors]="true"
              ></app-calendar>
            </app-field>
          </div>
          <div class="col-12 md:col-6">
            <app-field label="Do" for="override-to">
              <app-calendar
                [formCtrl]="toCtrl"
                formCtrlId="override-to"
                [timeOnly]="true"
                [ctrlShowTime]="true"
                dateFormat=""
                panelStyleClass="admin-settings-time-picker"
                ctrlPlaceholder="Izaberite vreme"
                [hideErrors]="true"
              ></app-calendar>
            </app-field>
          </div>
        </div>
      }
    </app-field>
  </div>

  <ng-template #header>
    <div class="flex align-items-start justify-content-between w-full gap-3">
      <div class="flex align-items-start gap-3">
        <div class="flex justify-content-center align-items-center icon">
          <app-calendar-minus-02 stroke="#414651" width="20px" height="22px"></app-calendar-minus-02>
        </div>
        <div class="flex flex-column gap-1">
          <div class="text-lg-semibold text-gray-900">Dodaj neradan dan</div>
          <div class="text-sm-regular text-gray-600">
            Definišite neradan dan ili period za administrativni panel.
          </div>
        </div>
      </div>
      <app-x-close
        stroke="#ADB0B8"
        width="12"
        height="12"
        class="cursor-pointer"
        (click)="onCancel()"
      ></app-x-close>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="mt-2 flex justify-content-end align-items-center w-full">
      <app-button
        [btnSeverity]="ButtonSeverity.SECONDARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onCancel()"
      >
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button
        class="ml-2-5"
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onSubmit()"
      >
        <div class="text-sm-semibold text-white">Sačuvaj</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
